/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/inviteUser.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { SEND_PURCHASE_REFERALS } from "../graphql";
import { VApplication } from "../../../application";
import notification from "../config/notifications.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { pretty } from "@vlinder-web/utils-react";

const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface SendPurchaseInviteUserProps {
  presentation: any;
  section?: any;
  type?: any;
  userEmail?: any;
  notes?:any
}
export interface ISendPurchaseInviteMethods extends IPluginMethodMap {
  sendPurchaseInviteUser(args: SendPurchaseInviteUserProps): Promise<any>;
}

export class SendPurchaseInviteUserService implements IAgentPlugin {
  readonly methods: ISendPurchaseInviteMethods;

  constructor() {
    this.methods = {
      sendPurchaseInviteUser: this.sendPurchaseInviteUser.bind(this),
    };
  }

  async sendPurchaseInviteUser(args: SendPurchaseInviteUserProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const sendInvite = this.createInviteObjects(args);
    console.log("send single purchase invite=====", pretty(sendInvite));

    const isValid = this.validateArgs(args);
    if  ( isValid?.isValidate ){
      throw new Error(isValid?.errorMessage);
    }

    try {
      if (client) {
        const res = await client.mutate({
          mutation: SEND_PURCHASE_REFERALS,
          variables: {
            data: sendInvite,
            presentation: args?.presentation,
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.sendPurchaseReferals,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
      err?.graphQLErrors &&
      Array.isArray(err?.graphQLErrors) &&
      err?.graphQLErrors.find((item: any) => item.extensions);
    if (_display_message?.extensions?.display_message) {
      throw Error(_display_message?.extensions?.display_message);
    }

    throw err;
    }
  }

  private createInviteObjects(data: any) {
    const {
      presentation,
      type,
      section,
      userEmail,
      partition,
      sectionOptType,
      notes
    } = data;
    const inviteObjects: any = [];

    userEmail.forEach((email: any) => {
      let inviteObj = {};
      if(notes){
        inviteObj = {
          email,
          partition,
          inviteType: "Closed",
          sectionOptType,
          sections: section,
          inviteNote:notes
        };
      }
      else{
        inviteObj = {
          email,
          partition,
          inviteType: "Closed",
          sectionOptType,
          sections: section,
        };
      }
      inviteObjects.push(inviteObj);
    });

    return inviteObjects;
  }

  private validateArgs ( args : any ) : any {
    let message = {
      isValidate : false,
      errorMessage : ""
    }
    const {
      presentation,
      type,
      section,
      userEmail,
      partition,
      sectionOptType,
    } = args;
    if (  presentation === "" || presentation === null ||  presentation === undefined ){
        message = {
          ...message,
          isValidate : true,
          errorMessage : "Presentation Option Type cannot be Empty",
        }
        return message;
    }
    if (  partition === "" || partition === null ||  partition === undefined || partition === "-" ){
      message = {
        ...message,
        isValidate : true,
        errorMessage : "Partition cannot be Empty",
      }
      return message;
    }
    if ( sectionOptType === "" || sectionOptType === null ||  sectionOptType === undefined || sectionOptType === "-" ){
      message = {
        ...message,
        isValidate : true,
        errorMessage : "Section Option Type cannot be Empty",
      }
      return message;
    }
    if ( partition === "Default" ||  partition === "SpecialReserve"){
      if ( section !== null ) {
        message = {
          ...message,
          isValidate : true,
          errorMessage : `Section Should be Null for partition type ${partition}`,
        }
        return message;
      }
    }
    if ( partition === "SectionSpecific" ){
      if ( section === null ||  section === "" || section === "-" || section === undefined ) {
        message = {
          ...message,
          isValidate : true,
          errorMessage : `Section Id Should be not empty`,
        }
      }
    }
    return message;
  }
}



// {
//   "email": "te3@testing.io",
//   "partition": "SectionSpecific",
//   "presentation": "645dc1b92f6aaa6fda1f6fcc",
//   "sectionOptType": "Base 1",
//   "sections": "645dc1ff2f6aaa6fda1f6fd1"
// }
